if (!customElements.get('lcdh-contact-map')) {
  customElements.define('lcdh-contact-map', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const details = this.querySelector('details');
      const frame = this.querySelector('iframe');
      if (!details || !frame) return;
      details.addEventListener('toggle', () => {
        if (details.open && frame.dataset.src) {
          frame.src = frame.dataset.src;
          delete frame.dataset.src;
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
